import { styled } from '@mui/material';

import { I18nResources, useI18n } from '@app-velocity/i18n';

export type StepStatus = 'finished' | 'active' | 'waiting';

export type StepProps = {
  label: I18nResources;
  status: StepStatus;
};

const indicatorColorByStatus = {
  finished: 'var(--color-blue-50)',
  active: 'var(--color-blue-500)',
  waiting: 'var(--color-neutral-400)',
};

const labelColorByStatus = {
  finished: 'var(--color-neutral-500)',
  active: 'var(--color-neutral-900)',
  waiting: 'var(--color-neutral-600)',
};

const StepContainer = styled('div')({
  flex: 1,
});

const StepLabel = styled('span')<{ status: StepStatus }>(({ status }) => ({
  fontSize: 12,
  marginBottom: 8,
  display: 'block',
  color: labelColorByStatus[status],
}));

const StepIndicator = styled('span')<{ status: StepStatus }>(({ status }) => ({
  display: 'block',
  height: 4,
  borderRadius: 2,
  width: '100%',
  background: indicatorColorByStatus[status],
}));

export const Step = ({ label, status }: StepProps) => {
  const { t } = useI18n();

  return (
    <StepContainer>
      <StepLabel status={status}>{t(label)}</StepLabel>
      <StepIndicator status={status} />
    </StepContainer>
  );
};
